var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed, observable, autorun } from "mobx";
import { NamedRoutes } from "./NamedRoutes";
import { NOT_LOADED } from "../Infra/RemoteData";
import { filterNull } from "healthex-common/utils";
import { assertUserTypeOptional } from "healthex-common/checkusertype";
import { UserType } from "healthex-common/user.dtos";
export class WelcomeBackOrgUserViewModel {
    constructor(container) {
        this.organization = NOT_LOADED;
        this.welcomeUserUIManager = container.welcomeUserUIManager;
        this.authManager = container.authManager;
        this.routingUIManager = container.routingUIManager;
        this.organizationsManager = container.organizationsManager;
        autorun(async () => {
            this.organization = await this.loadOrganization();
        });
    }
    get isOrgSetupComplete() {
        if (this.organization === NOT_LOADED || this.organization === null)
            return false;
        return this.organization.setupComplete;
    }
    get name() {
        if (this.organization === NOT_LOADED || this.organization === null)
            return null;
        return this.organization.name;
    }
    get address() {
        if (this.organization === NOT_LOADED || this.organization === null)
            return null;
        return this.organization.address;
    }
    get city() {
        if (this.organization === NOT_LOADED || this.organization === null)
            return null;
        return this.organization.city;
    }
    get state() {
        if (this.organization === NOT_LOADED || this.organization === null)
            return null;
        return this.organization.state;
    }
    get zip() {
        if (this.organization === NOT_LOADED || this.organization === null)
            return null;
        return this.organization.zip;
    }
    get logo() {
        if (this.organization === NOT_LOADED || this.organization === null)
            return null;
        return this.organization.logoUrl;
    }
    get patientPortalLink() {
        if (this.organization === NOT_LOADED || this.organization === null)
            return null;
        if (this.organization.type !== UserType.HEALTHCARE_ORGANIZATION)
            return null;
        return this.organization.patientPortalLink;
    }
    get isOrgBasicSetupComplete() {
        if (this.organization === NOT_LOADED || this.organization === null)
            return false;
        if (this.organization.type === UserType.HEALTHCARE_ORGANIZATION) {
            const parts = filterNull([this.name, this.address, this.city, this.state, this.zip]);
            return parts.length === 5;
        }
        const parts = filterNull([this.name]);
        return parts.length === 1;
    }
    get isOrgCustomizationSetupComplete() {
        if (this.organization === NOT_LOADED || this.organization === null)
            return false;
        return this.logo !== null;
    }
    get isOrgAdmin() {
        return this.authManager.isOrgAdmin;
    }
    get isHealthcareOrg() {
        return this.authManager.userType === UserType.HEALTHCARE_ORGANIZATION;
    }
    go() {
        if (this.authManager.isUserProfileEmpty) {
            this.routingUIManager.navigateTo(NamedRoutes.WELCOME_ORG_USER_DETAILS);
        }
        else if (this.isOrgAdmin && !this.isOrgBasicSetupComplete) {
            this.routingUIManager.navigateTo(NamedRoutes.WELCOME_BASIC_ORG_DETAILS);
        }
        else if (this.isHealthcareOrg && this.isOrgAdmin && !this.isOrgCustomizationSetupComplete) {
            this.routingUIManager.navigateTo(NamedRoutes.WELCOME_CUSTOMIZE_ORG_DETAILS);
        }
        else if (this.isOrgAdmin) {
            this.routingUIManager.navigateTo(NamedRoutes.WELCOME_ORG_USER_INVITE);
        }
    }
    startFromBeginning() {
        this.routingUIManager.navigateTo(NamedRoutes.WELCOME_ORG_USER_DETAILS);
    }
    async loadOrganization() {
        if (!this.authManager.orgId)
            return null;
        if (!this.authManager.userType)
            return null;
        if (this.authManager.userType !== UserType.HEALTHCARE_ORGANIZATION && this.authManager.userType !== UserType.EXTERNAL_RESEARCHER)
            return null;
        try {
            return assertUserTypeOptional(await this.organizationsManager.loadOrganization(this.authManager.orgId), this.authManager.userType);
        }
        catch (e) {
            return null;
        }
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], WelcomeBackOrgUserViewModel.prototype, "organization", void 0);
__decorate([
    computed,
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], WelcomeBackOrgUserViewModel.prototype, "isOrgSetupComplete", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], WelcomeBackOrgUserViewModel.prototype, "name", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], WelcomeBackOrgUserViewModel.prototype, "address", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], WelcomeBackOrgUserViewModel.prototype, "city", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], WelcomeBackOrgUserViewModel.prototype, "state", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], WelcomeBackOrgUserViewModel.prototype, "zip", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], WelcomeBackOrgUserViewModel.prototype, "logo", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], WelcomeBackOrgUserViewModel.prototype, "patientPortalLink", null);
__decorate([
    computed,
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], WelcomeBackOrgUserViewModel.prototype, "isOrgBasicSetupComplete", null);
__decorate([
    computed,
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], WelcomeBackOrgUserViewModel.prototype, "isOrgCustomizationSetupComplete", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], WelcomeBackOrgUserViewModel.prototype, "isOrgAdmin", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], WelcomeBackOrgUserViewModel.prototype, "isHealthcareOrg", null);
